module.exports = __webpack_public_path__ + "img/p6_avatar.3ec73c71.png";